/* ============================================================
   MOG compatibility layer — 2026-08-03 audit remediation.
   Classic ES5 script (parses on every browser back to IE9).
   Modern browsers exit both blocks immediately at near-zero cost.
   ============================================================ */
(function () {
  'use strict';

  /* ---- 1) Pre-module browsers (Windows XP class: Chrome <=60,
     FF <=59, IE): theme JS cannot run there, so the site is
     read-only. Offer the phone/email path in a dignified banner
     instead of leaving dead controls. ---- */
  try {
    if (!('noModule' in document.createElement('script'))) {
      var addBanner = function () {
        if (document.getElementById('mog-legacy-banner')) return;
        var d = document.createElement('div');
        d.id = 'mog-legacy-banner';
        d.setAttribute('style',
          'background:#27436b;color:#f7f4ee;padding:14px 18px;text-align:center;' +
          'font:14px/1.6 Georgia,serif;');
        d.innerHTML =
          'This browser is too old to display our boutique fully. ' +
          'Please call <a style="color:#c9a76b" href="tel:+61494924659">+61 494 924 659</a> ' +
          'or email <a style="color:#c9a76b" href="mailto:sales@ministryofgems.com.au">sales@ministryofgems.com.au</a> ' +
          '&mdash; we are delighted to assist personally.';
        if (document.body) document.body.insertBefore(d, document.body.firstChild);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', addBanner);
      } else {
        addBanner();
      }
    }
  } catch (e) { /* never break the page */ }

  /* ---- 2) <dialog> shim for engines that run the theme's module JS
     but lack dialog support (Safari/iOS 15.0-15.3, FF 93-97):
     without this, cart / search / menu drawer / quick-add / filters
     silently do nothing because showModal() does not exist. ---- */
  try {
    var needsShim = !window.HTMLDialogElement ||
      !window.HTMLDialogElement.prototype ||
      typeof window.HTMLDialogElement.prototype.showModal !== 'function';
    if (!needsShim) return;

    var style = document.createElement('style');
    style.textContent =
      'dialog:not([open]){display:none!important}' +
      'dialog.mog-dialog-shim-open{display:block;position:fixed;top:0;right:0;bottom:0;left:0;' +
      'width:100%;height:100%;max-width:100%;max-height:100%;margin:0;padding:0;border:0;' +
      'background:#fff;overflow:auto;z-index:2147482000}';
    (document.head || document.documentElement).appendChild(style);

    var fireClose = function (el) {
      var ev;
      try { ev = new Event('close', { bubbles: false, cancelable: false }); }
      catch (err) { ev = document.createEvent('Event'); ev.initEvent('close', false, false); }
      el.dispatchEvent(ev);
    };

    var ensure = function (el) {
      if (!el || el.nodeName !== 'DIALOG') return;
      if (typeof el.showModal === 'function') return;
      el.showModal = function () {
        this.setAttribute('open', '');
        this.classList.add('mog-dialog-shim-open');
        this.open = true;
      };
      el.show = function () {
        this.setAttribute('open', '');
        this.open = true;
      };
      el.close = function (val) {
        if (typeof val !== 'undefined') this.returnValue = val;
        this.removeAttribute('open');
        this.classList.remove('mog-dialog-shim-open');
        this.open = false;
        fireClose(this);
      };
    };

    var patchAll = function () {
      var list = document.querySelectorAll('dialog');
      for (var i = 0; i < list.length; i++) ensure(list[i]);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', patchAll);
    } else {
      patchAll();
    }

    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            ensure(n);
            if (n.querySelectorAll) {
              var inner = n.querySelectorAll('dialog');
              for (var k = 0; k < inner.length; k++) ensure(inner[k]);
            }
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        var open = document.querySelector('dialog.mog-dialog-shim-open[open]');
        if (open && typeof open.close === 'function') open.close();
      }
    });
  } catch (e) { /* never break the page */ }
})();
